import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import {
    getGetUserSettingsUserIdQueryKey,
    useGetUserSettingsUserIdSuspense,
} from "api/generated/user-settings/user-settings";

export const getUserSettingsQueryKey = getGetUserSettingsUserIdQueryKey;

export function useUserSettingsQuery(userId: number) {
    return useGetUserSettingsUserIdSuspense(userId, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
